// @ts-strict-ignore
import {
  LMDataGridBaseComponent,
  LMEditorService,
  LMFormatterService,
  LMListEventService,
  LMListGridBuilderService,
  LMListGridPagingService,
  LMListGridUtilService,
  LMListSpecUtilService,
  LMListUtilService
} from './index';
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  LMBusyIndicatorService, LMCompoundFieldService,
  LMContextService, LMErrorUtilService,
  LMFormatUtilService,
  LMLoggerService, LMUrlInfoBuilderService,
  LMUrlUtilService
} from '@services/index';
import { Observable, Subject, Subscription } from 'rxjs';
import { AppConstants, LMConditionUtilService, LMUniqueIdService } from '@utils/index';
import { SohoMessageService } from 'ids-enterprise-ng';
import { ListResource } from '@resources/list.resource';
import { LMThemeService } from '@banner/lm-theme.service';
import * as urltemplate from 'url-template';

@Component({
  selector: 'lm-list-chart-aggregation',
  template: `
              <div soho-busyindicator
                  [style.height]="'100%'"
                  [text]="' '"
                  [blockUI]="true"
                  [displayDelay]="20"
                  [timeToComplete]="this.uiLoadingIndicatorTimeout"
                  [transparentOverlay]="true"
              >

                <div *ngIf="!hasChartData" soho-emptymessage
                    [emptyMessageOptions]="inProgress ? inProgressMessage : emptyMessage"
                    style="text-align: center; padding-top: 30px; top: 30%">
                </div>

                <div *ngIf="inProgress" [style.display]="'block'" [style.height]="'100px'"></div>

                <!-- USE FLEX LAYOUT -->
                <div class="scrollable-flex" [style.height]="'100%'">
                  <div class="scrollable-flex-content">
                    <div soho-datagrid #SohoDataGrid
                        *ngIf="gridOptions"

                        [attr.id]="datagridId"
                        [gridOptions]="this.gridOptions"
                        [emptyMessage]="this.sohoGridEmptyMessage"
                        [data]="data"
                        [style.display]="hasChartData ? 'block' : 'none'"

                        (cellchange)="onCellChange($event)"
                        (rowAdd)="onRowAdd($event)"
                        (closeFilterRow)="onCloseFilterRow($event)"
                        (contextMenu)="onContextMenu($event)"
                        (filtered)="onFilterPage($event)"
                        (keydown)="onKeyDown($event)"
                        (rendered)="onRendered($event)"
                        (rowActivated)="onRowActivated($event)"
                        (rowDeactivated)="onRowDeactivated($event)"
                        (rowClicked)="onRowClicked($event)"
                        (rowDoubleClicked)="onRowDoubleClicked($event)"
                        (selected)="onRowSelected($event)"
                        (settingsChanged)="onSettingsChanged($event)"
                        (sorted)="onSortPage($event)"
                    ></div>
                  </div>

                  <!-- FLEX FOOTER -->
                  <div soho-standalone-pager
                      id="{{listSpec.busListSpec.id}}_pager"
                      class="scrollable-flex-footer"
                      [attr.data-automation-id]="pagerAutomationId"
                      [attributes]="pagerIdAttributes"
                      [smallPageSizeSelector]="true"
                      [pageSizeMenuSettings]="{ attachToBody: true }"

                      [enableFirstButton]="enableFirstPage"
                      [enablePreviousButton]="enablePreviousPage"
                      [enableNextButton]="enableNextPage"
                      [enableLastButton]="enableLastPage"
                      [style.display]="hasChartData ? 'block' : 'none'"

                      [firstPageTooltip]="firstPageButtonTooltip"
                      [previousPageTooltip]="previousPageButtonTooltip"
                      [nextPageTooltip]="nextPageButtonTooltip"
                      [lastPageTooltip]="lastPageButtonTooltip"

                      [showPageSizeSelector]="showPagingSize"
                      [pageSize]="pageSize"
                      [pageSizes]="pageSizes"

                      (firstPage)="onFirstPage($event)"
                      (previousPage)="onPreviousPage($event)"
                      (nextPage)="onNextPage($event)"
                      (lastPage)="onLastPage($event)"
                      (pageSizeChange)="onPageSizeChange($event)"
                  ></div>
                </div>
              </div>
            `
})
export class LMListChartAggregationComponent extends LMDataGridBaseComponent implements LMListContentInterface, OnInit, AfterViewInit, AfterViewChecked, OnDestroy {

  @Input() set chartName(chartName: string) {
    // Safety check
    if (!chartName || this._chartName === chartName) {
      return;
    }

    this._chartName = chartName;
    if (this.initialBuildComplete) {
      this.chartNameChanged();
    }
  }

  @Input() sortOrder?: LMListSortOrder;

  data: any[];
  pageSize: number;
  firstPageButtonTooltip: string;
  previousPageButtonTooltip: string;
  nextPageButtonTooltip: string;
  lastPageButtonTooltip: string;
  enableFirstPage = true;
  enablePreviousPage = true;
  enableNextPage = true;
  enableLastPage = true;
  uiLoadingIndicatorTimeout = 0;
  initialBuildComplete = false;
  public sohoGridEmptyMessage: SohoEmptyMessageOptions = null;
  public pagerId: string;
  public pagerAutomationId: string;
  public pagerIdAttributes: SohoAttributesArray;
  public hasChartData = false;
  public inProgress = false;
  public inProgressMessage: SohoEmptyMessageOptions = { };
  public _chartName: string;
  public showPagingSize: boolean;
  private _chartNameChanged = false;
  private fLoadInitialData = false;
  private fFilterCriteriaChanged = false;
  private readonly implementsCancelablePaging;
  private cancelPagingNotifier$: Subject<boolean>;
  private initialPageSubscription: Subscription;
  private listEventSubs: Subscription[] = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmListGridUtilService: LMListGridUtilService,
    private lmListGridPagingService: LMListGridPagingService,
    protected lmConditionUtilService: LMConditionUtilService,
    protected lmEditorService: LMEditorService,
    protected lmFormatterService: LMFormatterService,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmListEventService: LMListEventService,
    protected lmListGridBuilderService: LMListGridBuilderService,
    protected lmLoggerService: LMLoggerService,
    protected lmThemeService: LMThemeService,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    protected lmListSpecUtilService: LMListSpecUtilService,
    protected lmListUtilService: LMListUtilService,
    protected lmCompoundFieldService: LMCompoundFieldService,
    protected sohoMessageService: SohoMessageService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected lmContextService: LMContextService,
    protected lmErrorUtilService: LMErrorUtilService,
  ) {
    super(
      lmConditionUtilService,
      lmContextService,
      lmEditorService,
      lmFormatterService,
      lmFormatUtilService,
      lmListEventService,
      lmListGridBuilderService,
      lmLoggerService,
      lmThemeService,
      lmUrlUtilService,
      lmListSpecUtilService,
      lmListUtilService,
      lmCompoundFieldService,
      sohoMessageService,
      lmUniqueIdService,
    );

    this.uiLoadingIndicatorTimeout = this.lmContextService.uiLoadingIndicatorTimeout;
    this.implementsCancelablePaging = this.lmContextService.isUiPagingRequestWaitTimeEnabled;
  }

  ngOnInit() {
    this.clearEmptyMessage();
    this.validateInitialInputs();
    this.build();
    this.initialBuildComplete = true;
    // Do not show the paging size selector in the paging bar if we are in a dashboard pane
    this.showPagingSize = !this.lmListSpecUtilService.isDashBoardContent(this.listSpec);
  }

  ngAfterViewInit() {
    this.getSavedColumns();
    if (this.savedColumns && this.savedColumns.length > 0) {
      this.sohoDataGridComponent.restoreUserSettings({ columns: this.savedColumns });
    }
    if (!this.listSpec.dependentList) {
      this.fLoadInitialData = true;
    }
  }

  ngAfterViewChecked() {
    if (!this.sohoDataGridComponent || this.componentDestroyed) {
      return;
    }

    if (this._chartNameChanged) {
      this.updateAggChartColumns();
    }

    if (this.fLoadInitialData) {
      this.fLoadInitialData = false;

      this.fFilterCriteriaChanged = false;
      if (this.listState?.filterCriteria) {
        this.filterCriteria = this.listState.filterCriteria;
        setTimeout(() => this.filterPage(this.listState.filterCriteria));
      } else {
        setTimeout(() => this.initialPage());
      }
    }

    if (this.fFilterCriteriaChanged
    ||  this._chartNameChanged) {
      this.fFilterCriteriaChanged = false;
      this._chartNameChanged = false;

      if (this.filterCriteria) {
        setTimeout(() => this.filterPage(this.filterCriteria));
      } else {
        setTimeout(() => this.initialPage());
      }
    }
  }

  ngOnDestroy() {
    this.setComponentDestroyed();

    if (this.initialPageSubscription && !this.initialPageSubscription.closed) {
      // ---------------------------------------------------------------------------------
      // If a call to the back end is still out then we want to
      // unsubscribe from it to cancel the client side processing
      // of the http client request.
      // ---------------------------------------------------------------------------------
      this.lmLoggerService.log([ this, this.instanceId, 'ngOnDestroy(): initialPageSubscription is still open, unsubscribing...' ]);
      this.initialPageSubscription.unsubscribe();
    }

    this.listEventSubs.forEach((sub: Subscription) => sub.unsubscribe());
  }

  protected loadManualData(): void {
    // Not implemented
  }

  protected onFormButtonClicked(columnDef: ListGridColumn, dataView: LMDataView, row: any, cell: any, navigationParams: any, event: any): void {
    // Not implemented
  }

  public fromDataViewChanged(): void {
    if (this.listState.filterCriteria) {
      setTimeout(() => this.filterPage(this.listState.filterCriteria));
    } else {
      setTimeout(() => this.initialPage());
    }
  }

  public onContextMenuItemSelected(actionReference: LMBusActionReference, selectedDataView?: LMDataView): void {
    // TODO
  }

  protected filterCriteriaChanged(): void {
    this.fFilterCriteriaChanged = true;
    this.changeDetectorRef.markForCheck();
  }

  protected chartNameChanged(): void {
    if (!this.initialBuildComplete) {
      return;
    }
    this._chartNameChanged = true;
    this.changeDetectorRef.markForCheck();
  }

  protected filterListCriteriaChanged(): void {
    // currently not supported.
  }

  public updateGridOptions(): void {
    // nothing to update.
  }

  public get datagridId(): string {
    if (!this.listSpec) {
      return null;
    }
    return this.listSpec.busListSpec.id + '_aggtable_datagrid';
  }

  onCloseFilterRow(event: SohoDataGridOpenFilterRowEvent) {
    this.m_filterCriteria = [];
    this.listState.filterCriteria = [];
    this.sohoDataGridComponent.clearFilter();
  }

  // overrides LMDataGridBaseComponent
  protected build(): void {
    this.pageSize = this.listPersonalization.pageSize || this.listSpec.busListSpec.showLines || this.listSpec.pageSize;

    this.pagerId = `${this.listSpec.busListSpec.id}_${this._chartName}_pager`;
    this.pagerAutomationId = `lm-${this.listSpec?.busListSpec?.automationId}_${this._chartName}-pager`;
    this.pagerIdAttributes = [
      { name: 'id', value: this.pagerId },
      { name: 'data-automation-id', value: this.pagerAutomationId }
    ];

    if (this.listEventSubs.length === 0) {
      this.listEventSubs.push(this.lmListEventService.listGridContinuePagingEvent$.subscribe((pagingEvent: LMListGridPagingEvent) => {
        this.onContinuePaging(pagingEvent);
      }));
    }

    this.lmEditorService.listSpec = this.listSpec;
    this.lmFormatterService.listSpec = this.listSpec;

    this.gridOptions = this.lmListGridBuilderService.buildAggregationDataGridOptions(this.listUrlInfo, this.listSpec, this.listState, this.listPersonalization, this._chartName);
    // ----------------------------------------------------------------
    // Used by grid formatters (and editors?) to get the dataViewSet
    // ----------------------------------------------------------------
    this.gridOptions.userObject = () => this;

    this.gridOptions.columns
      .map(column => <ListGridColumn> column)
      .forEach((column: ListGridColumn) => {
      // ----------------------------------------------------------------
      // if selection is disable run the rowClick event emitter
      // when clicking in a cell that's not a checkbox, link, or button
      // ----------------------------------------------------------------
        if (column.isActionable) {
          column.click = (event, args) => this.onColumnClicked(column, event, args);
        }
      });
  }

  private updateAggChartColumns() {
    const gridColumns = this.lmListGridBuilderService.buildColumnsForAggChart(this.listUrlInfo, this.listSpec, this._chartName);
    const gridColumnGroups = this.lmListGridBuilderService.buildColumnGroups(this.listSpec, false, this.listSpec.busListSpec.charts[this._chartName]);
    // Switch from agg chart1 with column groups to agg chart2 with no column groups results in script errors
    // since the datagrid does not reset the column groups to null.
    // https://github.com/infor-design/enterprise/issues/7720 - Datagrid UpdateColumns does not update the column groups when it is set to null.
    // But setting the column groups to an empty array adds an extra table row with blank headers
    // if (gridColumnGroups === null) {
    //   gridColumnGroups = [];
    // }
    // Reset column also does not work, since it calls updateColumns with null set to group headers, if the new definition does not have one.
    // this.sohoDataGridComponent.resetColumns();
    // Updating grid settings in build (above line 335) did not work since DataGrid attempts to merge old settings with new.
    gridColumns
      .map(column => <ListGridColumn> column)
      .forEach((column: ListGridColumn) => {
        if (column.isActionable) {
          column.click = (event, args) => this.onColumnClicked(column, event, args);
        }
      });
    this.lmListUtilService.updateColumnLabels(this.listSpec, this.dataViewSet, gridColumns, gridColumnGroups);
    this.sohoDataGridComponent.updateColumns(gridColumns, gridColumnGroups);
  }

  private handleInitialPageCancel() {
    this.enableFirstPage = false;
    this.enablePreviousPage = false;
    this.enableNextPage = false;
    this.enableLastPage = false;
    this.data = [];

    if (this.sohoDataGridComponent) {
      this.sohoDataGridComponent.removeSelected();
    }

    const message = '';
    const title = Soho.Locale.translate('NoDataAvailable');
    this.handleError(message, title);
    this.changeDetectorRef.markForCheck();
  }

  private handleCancelableRequest(): void {
    if (this.implementsCancelablePaging && this.cancelPagingNotifier$) {
      this.cancelPagingNotifier$.next(true);
      this.cancelPagingNotifier$.complete();
      this.cancelPagingNotifier$ = null;
    }
  }

  private handleCancelableResponse(response: LMListPagingResponse): boolean {
    if (this.implementsCancelablePaging) {
      if (response.status === 'STARTED') {
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'started', cancelablePagingNotifier: response.cancelablePagingNotifier });
        this.cancelPagingNotifier$ = response.cancelablePagingNotifier;
        return true;
      } else if (response.status === 'WAITING') {
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'waiting' });
        return true;
      } else if (response.status === 'CANCELED') {
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'canceled' });
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        return true;
      } else {
        this.cancelPagingNotifier$ = null;
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'finished' });
        return false;
      }
    } else {
      return false;
    }
  }

  private initialPage(): void {
    if (this.componentDestroyed) {
      return;
    }
    this.handleCancelableRequest();

    const url = this.buildInitialPageUrl();
    const initialNbrRecs = this.lmListUtilService.getInitialNumberOfRecs(this.listSpec, this.listState, this.pageSize);
    const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);

    // -------------------------------------------------------------
    // request the first page of records and log how long it took
    // -------------------------------------------------------------
    this.lmLoggerService.time({ id: 'LMListGrid.initialPage() ' + this.instanceId });
    this.hasChartData = false;
    this.inProgress = true;
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);
    this.initialPageSubscription = this.lmListGridPagingService.initialPage(url, initialNbrRecs, postContent, this.listState.columnarOptions).subscribe(
      (listPagingResponse: LMListPagingResponse) => {

        if (this.componentDestroyed) {
          return;
        }

        if (this.handleCancelableResponse(listPagingResponse)) {
          if (listPagingResponse.status === 'CANCELED') {
            this.handleInitialPageCancel();
          }
          return;
        }

        if (listPagingResponse.serverLog) {
          this.lmLoggerService.serverLog(listPagingResponse.serverLog);
        }

        this.lmLoggerService.timeEnd('LMListGrid.initialPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

        if (listPagingResponse.status === 'COMPLETED') {
          this.updateColumnVisibility(this.listSpec, listPagingResponse.dataViewSet);
          this.postInitialPage(listPagingResponse);
        } else {
          this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
            listPagingResponse.status, listPagingResponse.message);
        }
      },
      (error: any) => {
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        this.lmErrorUtilService.handleError(error);
      });
  }

  onBeforePaging(pageOp: LMPageOp, event: any) {
    const beforePagingEvent: LMListGridPagingEvent = { pageOp, sohoDataGridEvent: event };

    this.lmListEventService.listGridBeforePagingEvent(beforePagingEvent);
  }

  onContinuePaging(continuePagingEvent: LMListGridPagingEvent) {
    switch (continuePagingEvent.pageOp) {
      case 'first':
        this.onFirstPage(continuePagingEvent.sohoDataGridEvent, true);
        break;
      case 'last':
        this.onLastPage(continuePagingEvent.sohoDataGridEvent, true);
        break;
      case 'next':
        this.onNextPage(continuePagingEvent.sohoDataGridEvent, true);
        break;
      case 'previous':
        this.onPreviousPage(continuePagingEvent.sohoDataGridEvent, true);
        break;
      case 'filter':
        this.onFilterPage(continuePagingEvent.sohoDataGridEvent, true);
        break;
      case 'sort':
        this.onSortPage(continuePagingEvent.sohoDataGridEvent, true);
        break;
      case 'pagesize':
        this.onPageSizeChange(continuePagingEvent.sohoDataGridEvent, true);
        break;
    }
  }

  onPageSizeChange(args: any[], continuePaging = false) {
    if (!continuePaging) {
      this.onBeforePaging('pagesize', args);
      return;
    }

    this.pageSize = args[1].pagesize;
    this.listPersonalization.pageSize = args[1].pagesize;
    this.reloadPage();
  }

  /******************************************************************************
   * FIRST PAGE
   ******************************************************************************/
  onFirstPage(event: any, continuePaging = false): void {
    if (!continuePaging) {
      this.onBeforePaging('first', event);
      return;
    }

    this.handleCancelableRequest();
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);
    const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);

    // request the first page of records and log how long it took
    this.lmLoggerService.time({ id: 'LMListGrid.firstPage() ' + this.instanceId });
    this.lmListGridPagingService.firstPage(this.dataViewSet, this.pageSize, postContent, null).subscribe(
      (listPagingResponse: LMListPagingResponse) => {

        if (this.handleCancelableResponse(listPagingResponse)) {
          return;
        }

        if (listPagingResponse.serverLog) {
          this.lmLoggerService.serverLog(listPagingResponse.serverLog);
        }

        this.lmLoggerService.timeEnd('LMListGrid.firstPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

        if (listPagingResponse.status === 'COMPLETED') {
          this.processListPagingResponse(listPagingResponse, -1, 0);
          this.sohoDataGridComponent.scrollRowIntoView(0);
        } else {
          this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
            listPagingResponse.status, listPagingResponse.message);
        }
      },
      (error: any) => {
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        this.lmErrorUtilService.handleError(error);
      });
  }

  /******************************************************************************
   * LAST PAGE
   ******************************************************************************/
  onLastPage(event: any, continuePaging = false): void {
    if (!continuePaging) {
      this.onBeforePaging('last', event);
      return;
    }
    this.handleCancelableRequest();
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);
    const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);

    // request the last page of records and log how long it took
    this.lmLoggerService.time({ id: 'LMListGrid.lastPage() ' + this.instanceId });

    this.lmListGridPagingService.lastPage(this.dataViewSet, postContent, null).subscribe(
      (listPagingResponse: LMListPagingResponse) => {

        if (this.handleCancelableResponse(listPagingResponse)) {
          return;
        }

        if (listPagingResponse.serverLog) {
          this.lmLoggerService.serverLog(listPagingResponse.serverLog);
        }

        this.lmLoggerService.timeEnd('LMListGrid.lastPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

        if (listPagingResponse.status === 'COMPLETED') {
          this.processListPagingResponse(listPagingResponse, -1, 0);
          this.sohoDataGridComponent.scrollRowIntoView(0);
        } else {
          this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
            listPagingResponse.status, listPagingResponse.message);
        }
      },
      (error: any) => {
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        this.lmErrorUtilService.handleError(error);
      });
  }

  /******************************************************************************
   * NEXT PAGE
   ******************************************************************************/
  onNextPage(event: any, continuePaging = false): void {
    if (!continuePaging) {
      this.onBeforePaging('next', event);
      return;
    }
    this.handleCancelableRequest();
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);
    const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);

    // request the next page of records and log how long it took
    this.lmLoggerService.time({ id: 'LMListGrid.nextPage() ' + this.instanceId });
    this.lmListGridPagingService.nextPage(this.dataViewSet, postContent, null).subscribe(
      (listPagingResponse: LMListPagingResponse) => {

        if (this.handleCancelableResponse(listPagingResponse)) {
          return;
        }

        if (listPagingResponse.serverLog) {
          this.lmLoggerService.serverLog(listPagingResponse.serverLog);
        }

        this.lmLoggerService.timeEnd('LMListGrid.nextPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

        if (listPagingResponse.status === 'COMPLETED') {
          this.processListPagingResponse(listPagingResponse, -1, 0);
          this.sohoDataGridComponent.scrollRowIntoView(0);
        } else {
          this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
            listPagingResponse.status, listPagingResponse.message);
        }
      },
      (error: any) => {
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        this.lmErrorUtilService.handleError(error);
      });
  }

  /******************************************************************************
   * PREVIOUS PAGE
   ******************************************************************************/
  onPreviousPage(event: any, continuePaging = false): void {
    if (!continuePaging) {
      this.onBeforePaging('previous', event);
      return;
    }
    this.handleCancelableRequest();
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);
    const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);

    this.lmLoggerService.time({ id: 'LMListGrid.previousPage() ' + this.instanceId });
    this.lmListGridPagingService.previousPage(this.dataViewSet, postContent, null).subscribe(
      (listPagingResponse: LMListPagingResponse) => {

        if (this.handleCancelableResponse(listPagingResponse)) {
          return;
        }

        if (listPagingResponse.serverLog) {
          this.lmLoggerService.serverLog(listPagingResponse.serverLog);
        }

        this.lmLoggerService.timeEnd('LMListGrid.previousPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

        if (listPagingResponse.status === 'COMPLETED') {
          this.processListPagingResponse(listPagingResponse, -1, 0);
          this.sohoDataGridComponent.scrollRowIntoView(0);
        } else {
          this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
            listPagingResponse.status, listPagingResponse.message);
        }
      },
      (error: any) => {
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        this.lmErrorUtilService.handleError(error);
      });
  }

  /******************************************************************************
   * SORT PAGE
   ******************************************************************************/
  onSortPage(event: SohoDataGridSortedEvent, continuePaging = false): void {
    if (!continuePaging) {
      this.onBeforePaging('sort', event);
      return;
    }
    this.handleCancelableRequest();
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);

    const sortColumn = this.sohoDataGridComponent.columnById(event.sortId)[ 0 ];
    const sortAscending = event.sortAsc;
    const sortOrderName = sortColumn.displayField.fieldId;

    if (!this.listState.columnarOptions) {
      this.listState.columnarOptions = {};
    }

    this.listState.columnarOptions.selectedDimension = sortOrderName;
    this.listState.columnarOptions.selectedOrderBy = sortOrderName;
    this.listState.columnarOptions.isAscending = sortAscending;

    const url = this.buildInitialPageUrl(true);
    const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);

    this.listState.sortOrderCriteria = {
      sortOrderName,
      isAscending: sortAscending
    };

    // request the sorted page of records and log how long it took
    this.lmLoggerService.time({ id: 'LMListGrid.sortPage() ' + this.instanceId });
    this.lmListGridPagingService.sortPage(url, this.listState.filterCriteria, this.listState.sortOrderCriteria, this.pageSize, postContent, null).subscribe(
      (listPagingResponse: LMListPagingResponse) => {

        if (this.handleCancelableResponse(listPagingResponse)) {
          return;
        }

        if (listPagingResponse.serverLog) {
          this.lmLoggerService.serverLog(listPagingResponse.serverLog);
        }

        this.lmLoggerService.timeEnd('LMListGrid.sortPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

        if (listPagingResponse.status === 'COMPLETED') {
          // ----------------------------------------------------------------------------------
          // initial, filter and sort page should call postInitialPage
          // first, last, next, prev, and refresh/reload should call processListPagingResponse.
          // ----------------------------------------------------------------------------------
          listPagingResponse.resetSelection = true;
          this.postInitialPage(listPagingResponse);
        } else {
          this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
            listPagingResponse.status, listPagingResponse.message);
        }
      },
      (error: any) => {
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        this.lmErrorUtilService.handleError(error);
      });
  }

  /******************************************************************************
   * FILTER PAGE
   ******************************************************************************/
  onFilterPage(event: SohoDataGridFilteredEvent, continueFiltering = false): void {
    if (this.disabled) {
      // -------------------------------------------------------------
      // this is here until soho grid.js has a disabled state that
      // would restrict the filter bar field entry from messaging
      // this function.
      // -------------------------------------------------------------
      return;
    }

    if (event.op === 'clear' || !event.conditions || event.conditions.length === 0) {
      if (!this.listState.filterCriteria || this.listState.filterCriteria.length === 0) {
        // --------------------------------------------------------------------------
        // getting a 'filtered' event when closing the filter row. On the close
        // filter row event I set a flag and if we are asked to close a filter
        // we should only clear the filter if a filter has already ben executed
        // --------------------------------------------------------------------------
        return;
      }
    }

    if (!continueFiltering) {
      this.onBeforePaging('filter', event);
      return;
    }
    // --------------------------------------------------------------------------
    // setting filterCriteria input here will causes a filterCriteriaChanged()
    // message which will cause filterPage() to be called during the
    // ngAfterViewChecked lifecycle event.
    // --------------------------------------------------------------------------
    const pendingFilterCriteria = this.getFilterCriteria(event.conditions);

    if (this.lmListUtilService.areTheSameJson(pendingFilterCriteria, this.listState.filterCriteria)) {
      return;
    }

    if (this.validateFilterCriteria(pendingFilterCriteria)) {
      this.listState.filterCriteria = pendingFilterCriteria;
      this.lmListEventService.updateFilterCriteriaEvent(this.listState.filterCriteria);
    }
  }

  private filterPage(filterCriteria: LMFilterFieldCriteria[]) {
    this.handleCancelableRequest();
    this.lmLoggerService.log([ this, this.instanceId, 'datagrid.source - filtered called' ]);
    this.lmListGridUtilService.unSelectAllRows(this.sohoDataGridComponent);

    const url = this.buildInitialPageUrl(true);
    const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);

    // request the first page of records and log how long it took
    this.lmLoggerService.time({ id: 'LMListGrid.filterPage() ' + this.instanceId });
    this.hasChartData = false;
    this.inProgress = true;
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);
    this.lmListGridPagingService.filterPage(url, this.getCombinedFilterCriteria(), this.pageSize, postContent, this.sortOrder, null, null).subscribe(
      (listPagingResponse: LMListPagingResponse) => {

        if (this.handleCancelableResponse(listPagingResponse)) {
          return;
        }

        if (listPagingResponse.serverLog) {
          this.lmLoggerService.serverLog(listPagingResponse.serverLog);
        }

        this.lmLoggerService.timeEnd('LMListGrid.filterPage() ' + this.instanceId, [ this, this.dataViewSet, 'pageSize: ' + this.pageSize, 'filterCriteria:', this.m_filterCriteria ]);
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

        if (listPagingResponse.status === 'COMPLETED') {
          // ----------------------------------------------------------------------------------
          // initial, filter and sort page should call postInitialPage
          // first, last, next, prev, and refresh/reload should call processListPagingResponse.
          // ----------------------------------------------------------------------------------
          this.listState.filterCriteria = filterCriteria;
          this.listState.sortOrderCriteria = this.sortOrder;
          listPagingResponse.resetSelection = true;
          this.postInitialPage(listPagingResponse);
        } else {
          this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
            listPagingResponse.status, listPagingResponse.message);
        }
      },
      (error: any) => {
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        this.lmErrorUtilService.handleError(error);
      });
  }

  /*****************************************************************************
   * RELOAD PAGE
   *****************************************************************************/
  private reloadPage(): void {
    this.handleCancelableRequest();
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);

    const selectedRow = this.lmListGridUtilService.getSelectedIndex(this.sohoDataGridComponent, true);
    const activatedRow = this.lmListGridUtilService.getActivatedRow(this.sohoDataGridComponent, true);
    const postContent = this.lmListGridPagingService.buildPostContent(this.listUrlInfo, this.selectRequestData);

    // request the first page of records and log how long it took
    this.lmLoggerService.time({ id: 'LMListGrid.reloadPage() ' + this.instanceId });
    this.lmListGridPagingService.reloadPage(this.dataViewSet, this.pageSize, postContent, null, this._chartName).subscribe(
      (listPagingResponse: LMListPagingResponse) => {

        if (this.handleCancelableResponse(listPagingResponse)) {
          return;
        }

        if (listPagingResponse.serverLog) {
          this.lmLoggerService.serverLog(listPagingResponse.serverLog);
        }

        this.lmLoggerService.timeEnd('LMChartAggregation.reloadPage() ' + this.instanceId, [ this, this.dataViewSet, 'newPageSize: ' + this.pageSize ]);
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);

        if (listPagingResponse.status === 'COMPLETED') {
          this.processListPagingResponse(listPagingResponse, selectedRow, activatedRow);
        } else {
          this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
            listPagingResponse.status, listPagingResponse.message);
        }
      },
      (error: any) => {
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        this.lmErrorUtilService.handleError(error);
      });
  }

  public refresh(): Observable<any> {
    this.disableSelectionListener = true;
    this.unSelectAllRows();
    this.clearRowAndCellIndicators();

    return new Observable<any>(observer => {
      this.reloadPage();
      this.disableSelectionListener = false;

      observer.next(true);
      observer.complete();
    });
  }

  // Changes here should be reflected in lm-list-chart.ts::buildInitalPageUrl().
  private buildInitialPageUrl(forceUrlRebuild = false): string {
    let url: string;
    if (this.listSpec
    &&  this.listSpec.dependentList) {
      if (this.listState.currentPageUrl
        && !forceUrlRebuild
        && this._fromDataView.resourceId === this.listState.fromResourceId
        && this.lmUrlUtilService.allCsksMatchContext(this.listState.currentPageUrl)
      ) {
        // if the fromDataView hasn't changed and there is a currentPageUrl then load that
        // to keep our position in the dependent list.
        url = this.listState.currentPageUrl;
      } else {
        // else resolve template against the fromDataView's resourceId
        const compiledUrlTemplate = urltemplate.parse(this.listUrlInfo.initialDataUrl);
        url = compiledUrlTemplate.expand({ resourceId: this._fromDataView.resourceId });
      }
    } else if (this.listState.currentPageUrl
      && !forceUrlRebuild
      && this.lmUrlUtilService.hasSameParamValue(this.listState.currentPageUrl, this.listUrlInfo.initialDataUrl, 'savedFilter')
      && this.lmUrlUtilService.allCsksMatchContext(this.listState.currentPageUrl)
    ) {
      url = this.listState.currentPageUrl;
    } else {
      url = this.listUrlInfo.initialDataUrl;
    }

    return this.lmUrlUtilService.appendToQueryString(url, 'aggregation=' + this._chartName);
  }

  private processListPagingResponse(listPagingResponse: LMListPagingResponse, selectRow = -1, activatedRow = -1) {
    /**
     * Set the member dataViewSet variable
     */
    this.dataViewSet = listPagingResponse.dataViewSet;
    this.savedSearches = listPagingResponse.savedSearchDataViewSet;
    /**
     * Store the current paging url into list state
     */
    this.listState.currentPageUrl = this.lmUrlUtilService.removeParam(this.dataViewSet.pagingUrls.reloadPageUrl, 'aggregation');
    this.dataViewSet.pagingUrls.reloadPageUrl = this.lmUrlUtilService.removeParam(this.lmUrlUtilService.removeParam(
      this.dataViewSet.pagingUrls.reloadPageUrl, 'lk'), 'fk');

    if (listPagingResponse.status === AppConstants.STATUS_COMPLETED) {
      this.loadDataIntoDataGrid();
      // --------------------------------------------------------------
      // need in a timeout to make sure the datagrid is built and
      // loaded before attempting to call functions on it.
      // --------------------------------------------------------------
      setTimeout(() => {
        this.selectionInProgress = true;
        this.clearRowAndCellIndicators();

        // update the sort indicator
        this.updateSortColumn(this.listSpec, this.dataViewSet);

        if (activatedRow !== undefined && activatedRow > -1) {
          if (activatedRow >= this.dataViewSet.data.length) {
            activatedRow = this.dataViewSet.data.length - 1;
          }
          // https://jira.lawson.com/browse/LMCLIENT-25037
          if (activatedRow > -1) {
            this.activateRow(activatedRow);
          } else {
            // need to fire an event to update related content like detail panels  ?? see if cheryl will promote for me
            this.lmListEventService.dataLoadedEvent(listPagingResponse);
          }
        }

        if (selectRow > -1) {
          if (selectRow >= this.dataViewSet.data.length) {
            selectRow = this.dataViewSet.data.length - 1;
          }
          this.lmListGridUtilService.selectRow(this.sohoDataGridComponent, selectRow);
        }
        this.selectionInProgress = false;
      });
    } else {
      // todo handle other landmark return status'
    }
  }

  private loadDataIntoDataGrid() {
    if (this.disabled) {
      // safety - in case function is called when disabled
      this.disableComponent();
      return;
    }

    this.enableFirstPage = this.dataViewSet.pagingInfo.hasPrevious && !this.dataViewSet.pagingInfo.firstDisabled && this.dataViewSet.data.length > 0;
    this.enablePreviousPage = this.dataViewSet.pagingInfo.hasPrevious && !this.dataViewSet.pagingInfo.previousDisabled && this.dataViewSet.data.length > 0;
    this.enableNextPage = this.dataViewSet.pagingInfo.hasNext && !this.dataViewSet.pagingInfo.nextDisabled && this.dataViewSet.data.length > 0;
    this.enableLastPage = this.dataViewSet.pagingInfo.hasNext && !this.dataViewSet.pagingInfo.lastDisabled && this.dataViewSet.data.length > 0;

    this.firstPageButtonTooltip = !this.enableFirstPage && this.dataViewSet.pagingInfo.firstDisabledReason ?
      this.dataViewSet.pagingInfo.firstDisabledReason : Soho.Locale.translate('FirstPage');

    this.previousPageButtonTooltip = !this.enablePreviousPage && this.dataViewSet.pagingInfo.previousDisabledReason ?
      this.dataViewSet.pagingInfo.previousDisabledReason : Soho.Locale.translate('PreviousPage');

    this.nextPageButtonTooltip = !this.enableNextPage && this.dataViewSet.pagingInfo.nextDisabledReason ?
      this.dataViewSet.pagingInfo.nextDisabledReason : Soho.Locale.translate('NextPage');

    this.lastPageButtonTooltip = !this.enableLastPage && this.dataViewSet.pagingInfo.lastDisabledReason ?
      this.dataViewSet.pagingInfo.lastDisabledReason : Soho.Locale.translate('LastPage');

    this.data = this.dataViewSet.data;
    this.hasChartData = (this.data && this.data.length > 0);
    this.inProgress = false;
    this.setEmptyMessage();
    this.sohoGridEmptyMessage = this.emptyMessage;

    this.changeDetectorRef.markForCheck();
  }

  private clearRowAndCellIndicators(): void {
    if (this.sohoDataGridComponent) {
      this.sohoDataGridComponent.clearDirty();
    }
  }

  private updateSortColumn(listSpec: LMListSpec, dataViewSet: LMDataViewSet): void {
    this.listSpec.busListSpec.displayFields
      .filter(displayField => displayField.fieldId === this.dataViewSet.pagingInfo.sortOrderName)
      .forEach(displayField => {
        const visibleColumns = this.sohoDataGridComponent.getColumns();
        const column: ListGridColumn = this.getFirstVisibleColumnForFieldId(displayField.fieldId, visibleColumns);
        if (column != null) {
          this.sohoDataGridComponent.setSortIndicator(column.id, this.dataViewSet.pagingInfo.isAscending);
        }
      });
  }

  private getFirstVisibleColumnForFieldId(fieldId: string, visibleColumns: Array<ListGridColumn>): ListGridColumn {
    const foundColumn: ListGridColumn = visibleColumns.find(column => column.fieldId === fieldId);
    return foundColumn;
  }

  private disableComponent() {
    this.enableFirstPage = false;
    this.enablePreviousPage = false;
    this.enableNextPage = false;
    this.enableLastPage = false;
    this.data = [];

    if (this.sohoDataGridComponent) {
      this.sohoDataGridComponent.removeSelected();
    }

    this.setEmptyMessage();
    this.sohoGridEmptyMessage = this.emptyMessage;

    this.changeDetectorRef.markForCheck();
  }

  /**
   * Assumes this.dataViewSet is already set.
   * @param gridPagingRequest
   * @param gridPagingResponse
   */
  private postInitialPage(listPagingResponse: LMListPagingResponse) {

    this.updateColumnLabels(this.listSpec, listPagingResponse.dataViewSet);
    this.processListPagingResponse(listPagingResponse, this.getSelectedRow());

    /**
     * Reset the listResource to be the rangeViewKey + listName once a dataViewSet
     * is initially loaded. This will be the actual listResource used for anything
     * else that happens in the client.
     *
     * This is needed for:
     * - When this list becomes a sourceResource to another list.
     * - Opening a create form, the list will have the range keys.
     *
     *  Phillip
     */
    // List resource will be that of targetList and it is used to perform create or update.
    // So do not overwrite the listResource based on dataviewSet header.
    this.listResource = new ListResource({
      resourceId: this.dataViewSet.header.resourceId,
      listName: this.listSpec.busListSpec.name,
      chartName: this._chartName
    });

    this.updateFilterBar();
    this.updateSortColumn(this.listSpec, listPagingResponse.dataViewSet);

    /**
     * fire dataloaded event once datagrid has been initially loaded with data.
     * Do not fire for any other paging requests other than 'initial', 'sort' or 'filtered'.
     * Must put this into a timeout so a timeout in sohoxi (which un-selects
     * all rows) can execute first.
     */
    setTimeout(() => this.lmListEventService.dataLoadedEvent(listPagingResponse));
  }

  public onRowClicked(event: SohoDataGridRowClicked) {
    // fire this event to tell list to update audit compare values.
    // onRowSelected event didn't have a selected row.
    this.lmListEventService.listRowClickedEvent(<LMListRowClickedEvent>event);
  }

  public onRowDoubleClicked(event: SohoDataGridRowClicked): void {
    return;
  }

  public onRowSelected(event: SohoDataGridSelectedEvent) {
    return;
  }

  public onColumnClicked(columnDef: any, event: any, args: any) {

    const row = args[0].row;
    const cell = args[0].cell;
    const dataView = args[0].item;
    const navigationParams = event.target.dataset.navigationParams ? JSON.parse(event.target.dataset.navigationParams) : null;

    if (columnDef.displayField.linkNavigation ||
      columnDef.displayField.navigation ||
      columnDef.displayField.httpUrl ||
      navigationParams
    ) {
      const uiLinkEvent: LMUILinkEvent = {
        columnDef,
        dataView,
        event,
        navigationParams
      };
      this.lmListEventService.uiLinkEvent(uiLinkEvent);
    } else if (columnDef.displayField.type === AppConstants.FORMBUTTON ||
      columnDef.displayField.type === AppConstants.SUBFORM ||
      columnDef.displayField.type === AppConstants.FORMREFERENCE ||
      columnDef.displayField.type === AppConstants.LISTREFERENCE) {
      this.lmListEventService.formButtonEvent(<LMFormButtonEvent>{ columnDef, dataView, row, cell, event });
    } else if (columnDef.displayField.aggDrill) {
      // Send an event up with the url
      const options: LMUILinkEventOptions = { aggDrill: true, savedFilter: this.buildAggDrillDimensionFilter(dataView) };
      const uiLinkEvent: LMUILinkEvent = {
        columnDef,
        dataView,
        event,
        options,
      };
      this.lmListEventService.uiLinkEvent(uiLinkEvent);
    }
  }

  private buildAggDrillDimensionFilter(dataView: LMDataView): string {
    // Failed attempts
    // fc.filter did not work if the list did not have those columns defined
    // setting static keys did not work since the keyset and keys required to build the drill list resourceId is unknown in columnar list
    // Going with saved filter instead and it sticks around even if the user filters the list.

    // 1. filter=<filterString
    // return this.listSpec.busListSpec.charts[this._chartName].aggFields
    //   .filter((v) => !v.isTotal)
    //   .map((v) => '( ' + v.fieldId + ' = "' + encodeURIComponent(dataView.fields[v.fieldId].value as string) + '" )')
    //   .join (' and ');

    // 2. fc.field = eqauls(fieldValue)
    // return this.listSpec.busListSpec.charts[this._chartName].aggFields
    //   .filter((v) => !v.isTotal)
    //   .map((v) => 'fc.' + v.fieldId + '=equals(' + encodeURIComponent(dataView.fields[v.fieldId].value as string) +')')
    //   .join ('&');

    // 3. Add it to static keys
    // const staticKeys = this.listSpec.busListSpec.charts[this._chartName].aggFields
    //   .filter((v) => !v.isTotal)
    //   .map((v) => v.fieldId + '=' + encodeURIComponent(dataView.fields[v.fieldId].value as string))
    //   .join (',');
    // return dataView.resourceId.substring(0, dataView.resourceId.length - 1) + '|' + staticKeys + ')';

    // 4. savedFilter=<filterString>
    // The values will be encoded when ListComponent builds the URL.
    const columnarInstanceSelection = this.getDataViewSet().columnarInfo.aggFilter ? this.getDataViewSet().columnarInfo.aggFilter + ' and ': '';

    return columnarInstanceSelection
      + this.listSpec.busListSpec.charts[this._chartName].aggFields
        .filter((v) => !v.isTotal)
        .map((v) => '( ' + v.filterFieldId + ' = "' + (dataView.fields[v.fieldId].value as string) + '" )')
        .join (' and ');
  }

  /**
   * Call this one new data has come in but only on initialPage to
   * @param listSpec
   * @param dataViewSet
   */
  protected updateColumnVisibility(listSpec: LMListSpec, dataViewSet: LMDataViewSet) {
    const gridColumns: ListGridColumn[] = this.sohoDataGridComponent.getColumns();
    for (let i = gridColumns.length - 1; i >= 0; i--) {
      const gridColumn: ListGridColumn = gridColumns[ i ];
      const displayField: LMListDisplayField = gridColumn.displayField;
      if (displayField && displayField.columnVisibility) {
        const dataView = dataViewSet.header;

        if (this.lmConditionUtilService.isValid(displayField.columnVisibility, dataView)) {
          this.sohoDataGridComponent.showColumn(gridColumn.id);
        } else {
          this.sohoDataGridComponent.hideColumn(gridColumn.id);
        }
      }
    }
  }

  protected validateFilterCriteria(filterCriteria: LMFilterFieldCriteria[]): boolean {
    return true;
  }

  public activateRow(row: number, scrollIntoView?: boolean): void {
    if (this.sohoDataGridComponent) {
      this.sohoDataGridComponent.activateRow(row);
    }
  }

  protected updateFilterBar() {
  }

  public updateDataViewTransaction(key: number, status: string, message: string): void {
    // depending on the the status,
    // Complete - row marked pristine and successful
    // else - row marked in error
    // TODO how do we handle transactions that have bee canceled because
    // the user did not confirm the action or did not enter the required input
    // The cancelled transaction will have status AppConstants.CONFIRMATION_REQUIRED

    const rowStatus = AppConstants.STATUS_COMPLETED === status ? '' : 'error';
    this.rowStatus(key, rowStatus, message);
  }
}
